import { ISourceTypeInfo } from "./ISourceTypeInfo";
import { SourceType } from "./SourceType";

export class ManualSourceTypeInfo implements ISourceTypeInfo {
    public readonly sourceType: SourceType = SourceType.manualEntry;

    readonly displayName: string = "Manual Entry";

    readonly tooltipText: string = "Data can be manually entered or pasted into the input pane.";
}